import React from 'react';
import {
  Button,
  Tooltip
} from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useTranslation } from 'react-i18next';

/**
 * CreateMenuButton Component
 * 
 * A simple button to create a new project/case.
 * The collection creation functionality has been moved to be next to the collection dropdown.
 */
const CreateMenuButton = ({
  onCreateProject,
  primaryColor = '#5757b0',
  hoverColor = '#7777d0',
  lightPurple = '#f0f0ff'
}) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t('sidebar.create_new_case') || 'Create New Case'}>
      <Button
        variant="contained"
        onClick={onCreateProject}
        startIcon={<AddCircleIcon />}
        fullWidth
        sx={{
          backgroundColor: primaryColor,
          color: '#fff',
          fontWeight: 'bold',
          textTransform: 'none',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(87, 87, 176, 0.3)',
          transition: 'all 0.3s ease',
          '&:hover': {
            backgroundColor: hoverColor,
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 15px rgba(87, 87, 176, 0.4)',
          },
          '&:active': {
            transform: 'translateY(0)',
            boxShadow: '0 2px 10px rgba(87, 87, 176, 0.3)',
          },
          mb: 2
        }}
      >
        {t('sidebar.create_new_case') || 'New Case'}
      </Button>
    </Tooltip>
  );
};

export default CreateMenuButton;